import styled, {css, keyframes} from 'styled-components';


export const headerHeight = '64px';
export const desktopWidth = '1200px';
export const tabletWidth = '768px';
export const outlineColor = '#00BFA5';
export const warningColor = '#F3364E';
export const greenTextColor = '#00BFA5';

export const centeredFlex = `
  width: 100%;
  max-width: 470px; 
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto; 
`;

export const fontSize = (size, base = 16) => `
  font-size: ${size}px;
  font-size: calc(${size / base} * 1rem);
`;

const fadeIn = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1;}
`;

const rotate = keyframes`
 0% { transform: rotate(0deg);}
 100% { transform: rotate(360deg);}
`;

export const fadeInDelay = css`
    animation-name: ${fadeIn};
    animation-duration: 1s;
    animation-delay: 5s;
    animation-fill-mode: forwards;
`;

export const wh = (w, h = w) => `
  width: ${w};
  height: ${h};
`;

export const fadeInAnimation = css`
    animation-name: ${fadeIn};
    animation-duration: 0.8s;
`;

export const spinAnimation = css`
   animation-name: ${rotate};
   animation-duration: 1s;
   animation-iteration-count: infinite;
   animation-timing-function: linear;
`;


export const CTAButton = () => `
    display: block;
    padding: 12px;
    width: 100%;
    background: #00BFA5;
    color: #fff;
    border: 4px solid rgba(76, 194, 201, 0.24);
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 8px 8px 12px rgba(97, 119, 122, 0.08);
    border-radius: 20px;
    font-weight: 500;
    background-clip: padding-box; 
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    margin-top: 6px;
    cursor: pointer;
  
    
    &:hover,
    &:active {
       text-decoration: none;
    }
   
`;

export const screenPadding = `
  padding: 24px 6px 32px;
`;

export const MediumTitle = `
    ${fontSize(24)};
    line-height: 29px;
    text-align: center;
    color: #fff;
    font-weight: 600;
    
    @media screen and (max-width: 767px) {
      ${fontSize(18)};
    }   
`;


export const primaryGreenBtn = () => `
  padding: 12px;
  background: #00BFA5;
  border: 1px solid #00BFA5;
  box-sizing: border-box;
  border-radius: 24px;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  text-align: center;
  letter-spacing: -0.2px;
  cursor: pointer;
  
  &:disabled {
   opacity: 0.7; 
  }
`;

export const LoginBtn = () => `
    display: block;
    padding: 12px;
    width: 100%;
    height: 48px;
    background: #00BFA5;
    color: #fff;
    border: none;
    border-radius: 100px;
    font-weight: 500;  
    font-size: 16px;
    line-height: 18px;
`;

export const StyledCircle = () => ` 
  margin: 0 16px;
  width: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledName = styled.p`
  margin: 0;
  ${fontSize(16)};
  line-height: 21px;
  font-weight: 500;
  letter-spacing: -0.0376471px;
  color: #323232;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  max-width: 152px;
`;

export const StyledID = styled.p`
  margin: 0;
  font-weight: 300;
  ${fontSize(16)};
  line-height: 21px;
  letter-spacing: -0.0376471px;
  color: #848484;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledBootstrapAlert = (theme) => `
  ${wh('90%', 'auto')};
  max-width: 360px;
  min-height: 40px;
  position: absolute;
  top: calc(${headerHeight} + 20px);
  left: 50%;
  transform: translate(-50%, -20%);
  z-index: 1700;
  background-color: ${theme === 'error' ? '#FF7C7C' : '#00BFA5'};
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
  border-radius: 12px;
  color: #fff;
  ${fontSize(12)};
  line-height: 16px;
  cursor: pointer;
  padding-right: 40px;
  border-color: ${theme === 'error' ? '#FF7C7C' : '#00BFA5'};
  
  p {
      margin: 6px 0;
      ${fontSize(14)};
      line-height: 18px;
      font-weight: 300;
      overflow-wrap: break-word;

    }
  
   span {
      box-shadow: none;
      font-weight: 400;
      text-shadow: none;
    }
`;








